export enum editActions {
    SET_EDIT_NOTIFICATION = 'SET_EDIT_NOTIFICATION',
    DUPLICATE_NOTIFICATION = 'DUPLICATE_NOTIFICATION',
    SET_NOTIFICATION_TEMPLATE = 'SET_NOTIFICATION_TEMPLATE',
    NOTIFICATION_FIELD_VALUE_CHANGED = 'NOTIFICATION_FIELD_VALUE_CHANGED',
    LOAD_VISUAL_DESIGN_SETTINGS = 'LOAD_VISUAL_DESIGN_SETTINGS',
    SET_STEP = 'SET_STEP',
    SET_SHOW_TEMPLATES = 'SET_SHOW_TEMPLATES',
    SET_HIDE_TEMPLATES_BUTTON = 'SET_HIDE_TEMPLATES_BUTTON',
    PUBLISHED_STATE_FIELD_VALUE_CHANGED = 'PUBLISHED_STATE_FIELD_VALUE_CHANGED',
    SET_TRACK_VISUAL_DESIGN_TITLE = 'SET_TRACK_VISUAL_DESIGN_TITLE',
    SET_TRACK_VISUAL_DESIGN_DESCRIPTION = 'SET_TRACK_VISUAL_DESIGN_DESCRIPTION',
    SCHEDULING_STATE_FIELD_VALUE_CHANGED = 'SCHEDULING_STATE_FIELD_VALUE_CHANGED',
    RESET_EDIT = 'RESET_EDIT'
}
